<div>
  <!-- Config data for Widget -->
  <div class="metadata-block">
    <div class="metadata-title">Section Properties</div>
    <div>
      <div class="metadata-key" id="name-test">Section Name</div>
      <!-- <div class="metadata-value">{{data?.name}}</div> -->
      <div class="metadata-input-block">
        <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>        
        <input  (keypress)="keyPressAlphaNumeric($event)" id="sectionLabel"          
          class="metadata-input-field"
          placeholder="Label"
          label="Label"
          type="text"
          fxFlex="flex-grow"
          maxlength="50"
          [(ngModel)]="data.label"
        />
      </div>
      
    </div>
    <appMetadataWidget *ngIf="isFormIdEnabled" [data]="data"></appMetadataWidget>
    <!-- <div class="metadata-block">
        <div *ngIf="isEdit" fxLayout="row wrap">
            <div class="metadata-key">Label:</div>
            <input matInput class="metadata-input" id="label" 
                placeholder="Label" label="Label" type="text" 
                [(ngModel)]="data.label">
            <div class="metadata-key">Section:</div>
            <input matInput class="metadata-value" id="Sequence" 
                placeholder="Sequence" label="Sequence" 
                [(ngModel)]="data.seq" readonly>
        </div>
        <div *ngIf="isEdit" fxLayout="row wrap">            
            <mat-label class="metadata-key">Hide section <input class="metadata-value" label="Hidden" 
                type="checkbox" fxLayoutAlign="end" [(ngModel)]="data.hidden"></mat-label>
            <mat-label class="metadata-key">Hide sequence<input class="metadata-value" label="Hidden" 
                type="checkbox" fxLayoutAlign="end" [(ngModel)]="data.seqHidden" (change)="onSequenceHidden()"></mat-label>
        </div>
        <div *ngIf="isEdit" fxLayout="row wrap">                 
            <div class="metadata-key">Description:</div>
            <input matInput class="metadata-input" id="description" 
                placeholder="Description" label="Description" type="text" 
                [(ngModel)]="data.description">            
        </div>
    </div> -->
    <div>
      <div class="metadata-key">Enable Section</div>
      <div  class="metadata-key">
        <mat-label
          ><input
            class="metadata-value initial-checkbox"
            label="Hidden"
            type="checkbox"
            fxLayoutAlign="end"
            [(ngModel)]="data.isInitialQuestionEnabled"
        /></mat-label>
      </div>

      <!--This block should be hidden if checkbox is not enabled-->
      <div *ngIf="data.isInitialQuestionEnabled" class="metadata-input-block" id="form">
        <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>        
        <input
          class="metadata-input-field"
          id="initialSectionLabel"
          fxFlex="flex-grow"
          placeholder="Initial Question Label"
          type="text"
          maxLength= "50"       
          [(ngModel)]="data.initialQuestionLabel"/>
      </div>

      <div *ngIf="data.isInitialQuestionEnabled" class="metadata-input-block">
        <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>        
        <input
          class="metadata-input-field"
          id="initialSectionKey"
          fxFlex="flex-grow"
          placeholder="Initial Question Key"
          type="text"
          maxLength= "50"    
          (keypress)="keyPressAlphaNumeric($event)" 
          [(ngModel)]="data.initialQuestionKey"/>
      </div>
    </div>
    <div *ngIf="isShownFromWidgetArea" class="debug-msg">(*) widget</div>
  </div>
</div>